// import { Button, Form, Space, Typography } from "antd";
// import AppContent from "../../../common/AppContent";
// import AppPageHeader from "../../../common/PageHeader";
// const { Title } = Typography;
// const FinishingLineMapping = () => {
//   return (
//     <>
//       <AppContent
//         header={
//           <AppPageHeader
//             extra={
//               <Space>
//                 {/* <Button
//                   type={showFilter ? "danger" : "primary"}
//                   size="small"
//                   onClick={() => setShowFilter((prev) => !prev)}
//                   style={{ float: "right" }}
//                 >
//                   {`${showFilter ? "Close" : "Open"} Filter Option`}
//                 </Button>
//                 <Button
//                   key="3"
//                   size="small"
//                   type="primary"
//                   disabled={!hasPermission([NO_PERMISSION_REQUIRED])}
//                   onClick={handleAddNew}
//                 >
//                   {hasPermission([NO_PERMISSION_REQUIRED])
//                     ? "Add New"
//                     : "No Permission"}
//                 </Button> */}
//               </Space>
//             }
//             title={<Title level={5}>Finishing Line</Title>}
//           />
//         }
//         content={<>Finishing Line mapping is not implemented yet.</>}
//       />
//     </>
//   );
// };

// export default FinishingLineMapping;

import {
  Card,
  Col,
  InputNumber,
  message,
  Row,
  TimePicker,
  Tooltip,
  Typography,
} from "antd";
import dayjs from "dayjs";
import React, { useEffect } from "react";
import { MinusCircleOutlined, PlusCircleOutlined } from "@ant-design/icons";
import { Button, Form, Space } from "antd";
import "../HourlyProductionRecordHours/index.css";
import { getData, postData } from "apiServices/common";
import Tab from "./Tabs";

const FinishingLineMapping = () => {
  return (
    <Card
      title="Finishing Line Mapping Configurations"
      className="digitalization_hour"
    >
      <Tab />
    </Card>
  );
};

export default FinishingLineMapping;
